export default __webpack_public_path__ + "static/media/multi_icon.90d556af.svg";